import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Order-first flow strip: Scan › Order › Kitchen › Pay at counter.
 *
 * Its real job is expectation-setting, not navigation. We are the identity +
 * kitchen + points layer and never hold the bill, so the guest has to understand
 * from the first screen that this starts their order and earns points while the
 * MONEY still happens at the counter exactly as it always did. Showing the whole
 * path with "Pay at counter" as the visible last step does that before they have
 * typed anything.
 *
 * Steps are never tappable — nothing here is a shortcut, and a tappable-looking
 * step in a four-step strip invites a guest to try to skip to paying.
 */
const STEPS = ["scan", "order", "kitchen", "pay"];

export default function FlowStrip({ current = "order" }) {
  const { t } = useTranslation();
  const currentIndex = Math.max(0, STEPS.indexOf(current));

  return (
    <ol className="ss-flow" aria-label={t("scan_stay.flow.label")}>
      {STEPS.map((step, i) => {
        const state = i === currentIndex ? "on" : i < currentIndex ? "done" : "next";
        return (
          <li key={step} className={`ss-flow-step ${state}`}>
            <span className="ss-flow-dot" aria-hidden="true" />
            <span className="ss-flow-tx">{t(`scan_stay.flow.${step}`)}</span>
            {i < STEPS.length - 1 && (
              /* Logical-property chevron: flipped by the RTL rule in the
                 stylesheet rather than swapped for a different glyph here. */
              <span className="ss-flow-sep" aria-hidden="true">›</span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
